<template>
  <div>
    <div>
      <v-layout column class="mt-5">
        <v-flex xs12>
          <v-layout align-center justify-end fill-height>
            <!-- <v-btn rounded color="primary" class="text-capitalize mr-2" to="actors/new" v-if="$can('create actors')">
                Créer
                <v-icon right>mdi-plus-circle-outline</v-icon>
              </v-btn> -->
            <v-btn rounded color="primary" class="text-capitalize mr-2" :disabled="selected.length < 2"
              @click="generateCards(selected)" v-if="$can('generate cards')">
              Générer cartes
              <v-icon right>mdi-account-card-details-outline</v-icon>
            </v-btn>
            <v-btn rounded color="primary" class="text-capitalize mr-2" @click="listCards()" v-if="$can('view cards')">
              Voir cartes
              <v-icon right>mdi-eye-outline</v-icon>
            </v-btn>
            <v-btn rounded color="primary" class="text-capitalize mr-2" :disabled="selected.length < 2"
              @click="deleting(selected)" v-if="$can('delete any actor')">
              Supprimer
              <v-icon right>mdi-trash-can-outline</v-icon>
            </v-btn>
            <v-btn rounded color="primary" class="text-capitalize mr-2" to="actors/import" v-if="$can('import actors')">
              Importer
              <v-icon right>mdi-database-import</v-icon>
            </v-btn>
            <v-btn rounded color="primary" :disabled="selected.length < 2" class="text-capitalize mr-2"
              v-if="$can('export actors')">
              <download-excel :data="selected" :meta="json_meta" name="actors.xls" type="xls" v-if="role"
                :export-fields="role == 'super administrator' || role == 'administrateur' ? admin_actors_fields : actors_fields">
                Exporter
              </download-excel>
              <v-icon right>mdi-share-outline</v-icon>
            </v-btn>
            <v-btn :loading="loadExcel" :disabled="loadExcel" rounded color="primary" @click="exportGlobalActors()"
              class="text-capitalize mr-2" v-if="$can('export actors')">
              Export actors
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
    <div>
      <v-layout column class="mt-10">
        <v-flex xs12>
          <v-layout align-center justify-end fill-height>
            <v-text-field v-model="searchName" label="Filter par nom, prénom ou contact" solo class="mr-2">
              <template v-slot:append-outer>
                <v-btn rounded color="primary" class="text-capitalize mr-2" @click="searchActors()" :loading="loader"
                  :disabled="loading">
                  Rechercher
                  <v-icon right>mdi-magnify</v-icon>
                </v-btn>
                <v-btn rounded color="primary" class="text-capitalize mr-2" @click="filters()" :disabled="loading">
                  Filtres
                  <v-icon right>mdi-filter-outline</v-icon>
                </v-btn>
                <v-btn rounded color="primary" class="text-capitalize" @click="resetSearch()">
                  Réinitialiser
                  <v-icon right>mdi-filter-remove-outline</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
    <div v-show="filter">
      <v-layout column wrap class="mt-2"> Liste des filtres </v-layout>
      <v-layout column class="mt-2">
        <v-flex xs12>
          <v-layout align-center justify-end fill-height>
            <v-select :items="departments" v-model="department_id" item-text="name" item-value="id" label="Departement"
              solo class="mr-2" @click:clear="removeDepartment()" @change="loadMunicipalities()" clearable>
            </v-select>
            <v-select :items="municipalities" v-model="municipality_id" item-text="name" item-value="id" label="Commune"
              solo class="mr-2" @change="loadDistricts()" @click:clear="removeMunicipality()" clearable>
            </v-select>
            <v-select :items="districts" v-model="district_id" item-text="name" item-value="id" label="Arrondissement"
              solo class="mr-2" @change="loadTowns()" @click:clear="removeDistrict()" clearable>
            </v-select>
            <v-select :items="towns" v-model="town_id" item-text="name" item-value="id" label="Village"
              @click:clear="removeTown()" clearable solo>
            </v-select>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout column class="mt-2">
        <v-flex xs12>
          <v-layout align-center justify-end fill-height>
            <v-select :items="chains" v-model="value_chain_id" item-text="name" item-value="id" label="Chaine de valeur"
              solo class="mr-2" @click:clear="removeChain()" clearable>
            </v-select>
            <v-select :items="maillons" v-model="maillon_id" item-text="name" item-value="id" label="Maillon" solo
              class="mr-2" @click:clear="removeMaillon()" clearable>
            </v-select>
            <v-select :items="services" v-model="service_id" item-text="name" item-value="id" label="Service"
              @click:clear="removeService()" solo class="mr-2" clearable>
            </v-select>
            <v-select :items="organisations" v-model="organization_id" item-text="name" item-value="id"
              label="Organisation" solo class="mr-2" @click:clear="removeOrganization()" clearable>
            </v-select>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout column class="mt-2">
        <v-flex xs12>
          <v-layout align-center justify-end fill-height>
            <v-select :items="actor_types" v-model="type" item-text="name" item-value="name" label="Type" solo
              class="mr-2" @click:clear="removeType()" clearable>
            </v-select>
            <v-select :items="genders" v-model="gender" label="Genre" solo class="mr-2" @click:clear="removeGender()"
              clearable>
            </v-select>
            <v-select :items="ages" v-model="age" label="Age" solo class="mr-2" @click:clear="removeAge()" clearable>
            </v-select>
            <v-select :items="languages" v-model="language" item-text="name" item-value="name" label="Langue" solo
              class="mr-2" @click:clear="removeLanguage()" clearable>
            </v-select>
            <v-select :items="school_levels" v-model="instruction_level" item-text="name" item-value="name"
              label="Niveau d'instruction" clearable @click:clear="removeLevel()" solo>
            </v-select>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-row>

          <v-col cols="12" md="6">
            <v-menu v-model="menu1" :close-on-content-click="false" max-width="290">
              <template v-slot:activator="{ on }">
                <v-text-field :value="startDateMoment" @click:clear="removeStartDate()" clearable label="De" readonly
                  v-on="on" solo prepend-icon="mdi-calendar"></v-text-field>
              </template>
              <v-date-picker v-model="start_date" @change="reloadData(1)">
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="6">
            <v-menu v-model="menu2" :close-on-content-click="false" max-width="290">
              <template v-slot:activator="{ on }">
                <v-text-field :value="endDateMoment" @click:clear="removeEndDate()" clearable label="A" readonly
                  v-on="on" solo prepend-icon="mdi-calendar"></v-text-field>
              </template>
              <v-date-picker v-model="end_date" @change="reloadData(2)">
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>


      </v-layout>
    </div>

    <v-snackbar v-model="snackbar" :timeout="timeout" color="primary" :top="true" :right="true">
      {{ snackbar_message }}
    </v-snackbar>
    <div class="text-center" v-if="loading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
      <v-flex xs12>
        <div v-if="selected" class="mr-2">
          {{ selected.length }} / {{ totalItems }} sélectionnés
        </div>
      </v-flex>
      <v-data-table v-if="actors && role" v-model="selected"
        :headers="role == 'super administrator' || role == 'administrateur' ? adminHeaders : headers" :items="actors"
        :loading="loading" :mobile-breakpoint="600" loading-text="Loading... Please wait" show-select
        :page.sync="currentPage" :server-items-length="totalItems" :items-per-page.sync="rowsPerPageItems"
        :footer-props="footerProps" class="mt-2 mr-10">
        <template v-slot:item.full_name="{ item }">
          <td>
            <span v-if="item.card" class="mr-1">
              <v-icon v-if="item.card.card">mdi-account-card-details-outline</v-icon>
            </span>
            {{ item.full_name }}
          </td>
        </template>
        <template v-slot:item.maillons="{ item }">
          <td v-if="item.maillons">
            {{ item.maillons.map(item => item.name).join(', ') }}
          </td>
        </template>
        <template v-slot:item.action="{ item }">
          <v-menu bottom left transition="slide-y-transition">
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="showItem(item)" v-if="$can('view actors')">
                <v-list-item-action>
                  <v-btn fab icon dark small color="error" v-if="$can(
                'view actors'
              )
                ">
                    <v-icon>mdi-eye-outline</v-icon>
                  </v-btn>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Voir</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="editItem(item)" v-if="$can('edit all actors') || $can('edit own actors')">
                <v-list-item-action>
                  <v-btn fab icon dark small color="primary">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Modifier</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="deleting(item)" v-if="$can('delete own actors') || $can('delete any actor')">
                <v-list-item-action>
                  <v-btn fab icon dark small color="error">
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Supprimer</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="
                downloadPdf(item.id)">
                <v-list-item-action>
                  <v-btn fab icon dark small color="error">
                    <v-icon>mdi-arrow-collapse-down</v-icon>
                  </v-btn>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Fiche Con.</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </div>

    <div class="text-xs-center pt-2">
      <v-pagination v-model="currentPage" :length="pagination.last_page" total-visible="16">
      </v-pagination>
    </div>
    <v-layout justify-center>
      <v-dialog v-model="dialog_generate" persistent hide-overlay max-width="290">
        <v-card>
          <v-card-title class="headline">{{ dialog_title }}</v-card-title>
          <v-card-text>{{ delete_message }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="orange" @click="cancel()">Non</v-btn>
            <v-btn :loading="loading" :disabled="loading" rounded color="primary" @click="deleteItem()">Oui</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog" persistent hide-overlay max-width="550">
        <delete-with-password v-if="item" @cancel="cancel" @deleteItem="deleteItem" :item="item"
          :message="delete_message" :title="dialog_title"></delete-with-password>
      </v-dialog>
      <div class="text-center">
        <v-dialog v-model="dialog_dowload" :scrim="false" persistent hide-overlay max-width="290">
          <v-card>
            <v-card-title class="m-4">
              Téléchargement en cours...
              <v-progress-linear indeterminate color="primary" class="mb-0"></v-progress-linear>
            </v-card-title>
          </v-card>
        </v-dialog>
      </div>
    </v-layout>
    <!-- <v-card class="mx-auto pt-2" outlined>
        <v-card-title>Localisation des acteurs</v-card-title>
        <v-card-text class="text--primary">
          <v-container class="pt-2" fluid fill-height>
            <v-layout>
              <v-flex x12>
                <l-map ref="actorsMap" style="height: 600px; width: 100%" :zoom="zoom" :center="center">
                  <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                  <l-marker v-for="(marker, index) in markers" :key="index" :lat-lng="marker.position"
                    @add="$nextTick(() => $event.target.openPopup())">
                    <l-popup :content="marker.content"></l-popup>
                  </l-marker>
                </l-map>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Vue from 'vue'
import JsonExcel from 'vue-json-excel'
import axios from 'axios'
import Permissions from '~/mixins/Permissions'
import DeleteWithPassword from '~/components/DeleteWithPassword'
import FileSaver from 'file-saver'
import L from 'leaflet'
import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet'

Vue.component('downloadExcel', JsonExcel)

export default {
  name: 'actors-list-view',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    DeleteWithPassword
  },
  mixins: [Permissions],
  data() {
    return {
      filter: false,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 7,
      center: [9.239, 2.31],
      dialog: false,
      dialog_generate: false,
      dialog_dowload: false,
      actorId: null,
      searchTimer: null,
      all: [],
      loading: false,
      loader: false,
      value_chain_id: null,
      department_id: null,
      municipality_id: null,
      district_id: null,
      town_id: null,
      maillon_id: null,
      service_id: null,
      instruction_level: null,
      type: null,
      age: null,
      start_date: null,
      end_date: null,
      menu1: false,
      menu2: false,
      gender: null,
      organization_id: null,
      language: null,
      ages: ['< ou =35 ans', '>35 ans'],
      genders: ['Homme', 'Femme'],
      ids: [],
      footerProps: {
        'items-per-page-options': [5, 10, 15, 30, 50, 100, 500],
        'items-per-page-text': 'Lignes par page'
      },
      dialog_title: '',
      isBulkDelete: false,
      isBulkGenerate: false,
      isSingleDelete: false,
      isSingleGenerate: false,
      searchName: '',
      // pagination: {
      //     current: 1,
      //     last_page: 0,
      //     total: 0,
      //     rowsPerPage: 30
      // },
      snackbar: false,
      snackbar_message: '',
      delete_message: '',
      payload: {
        page: 1,
        size: 15
      },
      timeout: 5000,
      selected: [],
      adminHeaders: [
        { text: 'Code Unique', value: 'unique_code' },
        { text: 'Nom Complet', value: 'full_name', width: 150 },
        { text: 'Chaine de valeur', value: 'chain.name' },
        { text: 'Maillon', value: 'maillon.name' },
        { text: 'Departement', value: 'department.name' },
        { text: 'Commune', value: 'municipality.name' },
        { text: 'Ville/Village', value: 'town.name' },
        { text: 'Actions', value: 'action', sortable: false }
      ],
      headers: [
        { text: 'Code Unique', value: 'unique_code' },
        { text: 'Chaine de valeur', value: 'chain.name' },
        { text: 'Maillon', value: 'maillon.name' },
        { text: 'Departement', value: 'department.name' },
        { text: 'Commune', value: 'municipality.name' },
        { text: 'Ville/Village', value: 'town.name' },
        { text: 'Actions', value: 'action', sortable: false }
      ],
      actors_fields: {
        'Code Unique': 'unique_code',
        Sexe: 'gender',
        Age: 'precise_age',
        Type: 'type',
        'Contact(s)': 'contact',
        Adresse: 'address',
        Langue: 'language',
        "Niveau d'instruction": 'instruction_level',
        Fonction: 'fonction',
        'Chaine de valeur': 'chain.name',
        Organisation: 'organization.name',
        Pays: 'country.name',
        Departement: 'department.name',
        Commune: 'municipality.name',
        Arrondissement: 'district.name',
        'Ville/Village': 'town.name'
      },
      admin_actors_fields: {
        'Code Unique': 'unique_code',
        Nom: 'last_name',
        'Prenom(s)': 'first_name',
        Sexe: 'gender',
        Age: 'precise_age',
        Type: 'type',
        'Contact(s)': 'contact',
        Adresse: 'address',
        Langue: 'language',
        "Niveau d'instruction": 'instruction_level',
        Fonction: 'fonction',
        'Chaine de valeur': 'chain.name',
        Organisation: 'organization.name',
        Pays: 'country.name',
        Departement: 'department.name',
        Commune: 'municipality.name',
        Arrondissement: 'district.name',
        'Ville/Village': 'town.name'
      },
      loadExcel: false,
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      role: '',
      item: null,
      actors: [],
      totalItems: null,
      rowsPerPageItems: 15,
      currentPage: 1,
      pagination: {
        last_page: 1,
      },
      organisations: [],
      uri: '/api/actors?include=card,maillon,chain,country,department,municipality,district,town'

    }
  },
  created() {
    this.$checkPermission('view actors')
    this.fetchUtils()
    this.getUtils()
    if (this.authUser && this.authUser.user && this.authUser.user.roles[0]) {
      this.role = this.authUser.user.roles[0].name
    }
    this.$store.dispatch('fetchDepartments')
    this.$store.dispatch('fetchChains')
    this.$store.dispatch('fetchActorTypes')
    this.$store.dispatch('fetchSchoolLevels')
    this.$store.dispatch('fetchLanguages')
    this.$store.dispatch('fetchMaillons')
    this.$store.dispatch('fetchChains')
    this.$store.dispatch('fetchServices')
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.$refs.actorsMap.mapObject.invalidateSize()
    // })

    this.filteredMunicipalities = []
    this.filteredDistricts = []
    this.filteredTowns = []
  },

  computed: {
    authUser() {
      return this.$store.getters.authUser
    },
    markers() {
      const data = this.$store.getters.actors
      const newArr = []
      data.filter(function (item) {
        if (item.latitude !== null && item.longitude !== null) {
          newArr.push(item)
        }
        return null
      })
      const markersList = []
      for (const c of newArr) {
        const lat = c.latitude
        const lon = c.longitude
        markersList.push({
          id: c.id,
          position: L.latLng(lat, lon),
          content: c.first_name + ' ' + c.last_name
        })
      }
      return markersList
    },

    departments() { return this.$store.getters.departments; },
    municipalities() { return this.$store.getters.getMunicipalities; },
    districts() { return this.$store.getters.getDistricts; },
    towns() { return this.$store.getters.getTowns; },
    ...mapGetters([
      'departements',
      'maillons',
      'chains',
      'services',
      'languages',
      'actor_types',
      'school_levels'
    ]),
    startDateMoment() {
      return this.start_date
        ? this.$moment(this.start_date).format("D MMMM YYYY")
        : "";
    },

    endDateMoment() {
      return this.end_date
        ? this.$moment(this.end_date).format("D MMMM YYYY")
        : "";
    },
  },
  watch: {
    'rowsPerPageItems'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.payload.size = newVal;
        this.fetchUtils();
      }
    },
    'currentPage'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.payload.page = newVal;
        this.fetchUtils();
      }
    },
  },
  methods: {
    async fetchUtils() {
      this.loading = true
      const newUri = this.uri + '&page[number]=' + this.payload.page + '&page[size]=' + this.payload.size

      const results = (await axios.get(newUri)).data
      if (results.data) {
        this.actors = results.data
        this.currentPage = results.current_page
        this.totalItems = results.total
        this.rowsPerPageItems = parseInt(results.per_page)
        this.pagination.last_page = results.last_page
      }
      this.loading = false
    },
    showItem(item) {
      this.$router.push({ name: 'actors.show', params: { actorId: item.id } })
    },
    editItem(item) {
      this.$router.push({ name: 'actors.edit', params: { actorId: item.id } })
    },
    cancel() {
      this.isBulkDelete = false;
      this.isSingleDelete = false;
      this.isBulkGenerate = false;
      this.dialog = false;
      this.dialog_generate = false;
    },

    deleting(item) {
      if (Array.isArray(item) && item.length > 1) {
        this.item = 'multiple'
        this.ids = this.selected.map((item) => {
          return item.id
        })
        this.isBulkDelete = true
        this.dialog_title = 'Suppression'
        this.delete_message =
          'Etes-vous sûr de vouloir supprimer ces acteurs ?'
        this.dialog = true
      } else {
        this.item = item.unique_code
        if (Array.isArray(item) && item.length === 1) {
          this.actorId = item[0].id
        } else {
          this.actorId = item.id
        }

        this.isSingleDelete = true
        this.dialog_title = 'Suppression'
        this.delete_message = 'Etes-vous sûr de vouloir supprimer cet acteur ?'
        this.dialog = true
      }
    },
    async generateCards(data) {
      if (Array.isArray(data) && data.length > 1) {
        this.ids = this.selected.map((data) => {
          return data.id;
        });
        this.isBulkGenerate = true;
        this.dialog_title = "Génération de cartes";
        this.delete_message =
          "Etes-vous sûr de vouloir générer des cartes pour ces acteurs ?";
        this.dialog_generate = true;
      } else {
        if (Array.isArray(data) && data.length === 1) {
          this.actorId = data[0].id
        } else {
          this.actorId = data.id
        }

        this.isSingleGenerate = true
        this.dialog_title = 'Génération de cartes'
        this.delete_message =
          "Etes-vous sûr de vouloir générer une carte pour cet acteur ?";
        this.dialog_generate = true;
      }
    },
    async listCards() {
      this.$router.push({ name: 'actors.cards' })
    },

    async deleteItem() {
      this.item = ''
      if (this.isBulkDelete && this.isBulkGenerate === false) {
        this.bulkDelete()
      } else if (this.isSingleDelete && this.isSingleGenerate === false) {
        this.deleteSingle()
      }
      if (this.isBulkGenerate && this.isBulkDelete === false) {
        this.bulkGenerate()
      } else if (this.isSingleGenerate && this.isSingleDelete === false) {
        this.generateSingle()
      }
    },

    async downloadPdf(id) {
      this.dialog_dowload = true
      await axios.get(`/api/receipt-consents-pdf/${id}`)
        .then(response => {
          const base64PDF = response.data
          const byteCharacters = window.atob(base64PDF)
          const byteNumbers = new Array(byteCharacters.length)
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          const byteArray = new Uint8Array(byteNumbers)
          const blob = new Blob([byteArray], { type: 'application/pdf' })

          const url = window.URL.createObjectURL(blob)

          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Fiche_de_consentement.pdf')
          document.body.appendChild(link)

          link.click()

          window.URL.revokeObjectURL(url)
        })
        .catch(err => {
          console.log('Export error ', err)
        })

      this.dialog_dowload = false
    },
    async deleteSingle() {
      this.loading = true
      await axios.delete(`/api/actors/${this.actorId}`)
      this.reloadData()
      this.loading = false
      this.dialog = false
      this.snackbar = true
      this.selected = []
      this.isBulkDelete = false
      this.isSingleDelete = false
      this.snackbar_message = 'Acteur supprimé avec succès!'
    },
    async bulkDelete() {
      this.loading = true
      await axios.delete(`/api/actors/delete`, { params: { ids: this.ids } })
      this.reloadData()
      this.loading = false
      this.dialog = false
      this.snackbar = true
      this.selected = []
      this.isBulkDelete = false
      this.isSingleDelete = false
      this.snackbar_message = 'Acteurs supprimés avec succès!'
    },
    async generateSingle() {
      this.loading = true
      await axios.post(`/api/actors/generate/${this.actorId}`)
      this.reloadData()
      this.loading = false
      this.dialog = false
      this.snackbar = true
      this.selected = []
      this.isSingleGenerate = false
      this.isBulkGenerate = false

      this.snackbar_message = "La carte de l'acteur a été généré avec succès!"
      this.cancel()

    },
    async bulkGenerate() {
      this.loading = true
      await axios.post(`/api/actors/bulk-generate`, { ids: this.ids })
      this.reloadData()
      this.loading = false
      this.dialog = false
      this.snackbar = true
      this.selected = []
      this.isBulkGenerate = false
      this.isSingleGenerate = false
      this.snackbar_message = "Cartes d'acteurs générées avec succès!"
      this.cancel()
    },
    async reloadData() {
      this.loading = true
      let uri = '/api/actors?include=card,maillon,chain,country,department,municipality,district,town'

      if (this.value_chain_id) {
        uri = uri + '&value_chain_id=' + this.value_chain_id
      }

      if (this.start_date) {
        this.menu1 = false;

        uri = uri + "&start_date=" + this.start_date;
      }

      if (this.end_date) {
        this.menu2 = false;
        uri = uri + "&end_date=" + this.end_date;
      }
      if (this.department_id) {
        uri = uri + '&department_id=' + this.department_id
      }
      if (this.municipality_id) {
        uri = uri + '&municipality_id=' + this.municipality_id
      }
      if (this.district_id) {
        uri = uri + '&district_id=' + this.district_id
      }
      if (this.town_id) {
        uri = uri + '&town_id=' + this.town_id
      }
      if (this.value_chain_id) {
        uri = uri + '&value_chain_id=' + this.value_chain_id
      } if (this.maillon_id) {
        uri = uri + '&maillon_id=' + this.maillon_id
      } if (this.organization_id) {
        uri = uri + '&organization_id=' + this.organization_id
      }
      if (this.age) {
        uri = uri + '&age=' + this.age
      }
      if (this.type) {
        uri = uri + '&type=' + this.type
      }
      if (this.gender) {
        uri = uri + '&gender=' + this.gender
      }
      if (this.instruction_level) {
        uri = uri + '&instruction_level=' + this.instruction_level
      }
      if (this.service_id) {
        uri = uri + '&service_id=' + this.service_id
      }
      if (this.language) {
        uri = uri + '&language=' + this.language
      }
      if (this.searchName.length !== 0) {
        uri = uri + '&searchName=' + this.searchName
      }
      this.uri = uri

      this.fetchUtils()

      this.loading = false
    },
    filters() {
      this.filter = !this.filter
    },
    async searchActors() {
      this.loader = true
      await this.reloadData()
      this.loader = false
    },
    async resetSearch() {
      this.filteredMunicipalities = []
      this.filteredDistricts = []
      this.filteredTowns = []
      this.searchName = ''
      this.value_chain_id = null
      this.maillon_id = null
      this.service_id = null
      this.organization_id = null
      this.type = null
      this.age = null
      this.gender = null
      this.language = null
      this.instruction_level = null
      this.department_id = null
      this.municipality_id = null
      this.district_id = null
      this.town_id = null
      this.loader = true
      await this.reloadData()
      this.loader = false
    },

    async getUtils() {
      const { data } = await axios.get('/api/organizations')
      this.organisations = data;
    },


    loadMunicipalities() {
      let departement = this.department_id;
      this.$store.dispatch('loadMunicipalities', departement);
    },

    loadDistricts() {
      let commune = this.municipality_id;
      this.$store.dispatch('loadDistricts', commune);
    },

    loadTowns() {
      let arrond = this.district_id;
      this.$store.dispatch('loadTowns', arrond);
    },
    removeDepartment() {
      this.department_id = null
      this.reloadData()
    },
    removeMunicipality() {
      this.municipality_id = null
      this.reloadData()
    },
    removeDistrict() {
      this.district_id = null
      this.reloadData()
    },
    removeTown() {
      this.town_id = null
      this.reloadData()
    },
    removeChain() {
      this.value_chain_id = null
      this.reloadData()
    },
    removeMaillon() {
      this.maillon_id = null
      this.reloadData()
    },
    removeService() {
      this.service_id = null
      this.reloadData()
    },
    removeOrganization() {
      this.organization_id = null
      this.reloadData()
    },
    removeType() {
      this.type = null
      this.reloadData()
    },
    removeGender() {
      this.gender = null
      this.reloadData()
    },
    removeAge() {
      this.age = null
      this.reloadData()
    },
    removeLanguage() {
      this.language = null
      this.reloadData()
    },
    removeLevel() {
      this.instruction_level = null
      this.reloadData()
    },

    exportActors() {
      this.loadExcel = true
      axios
        .get('/api/actors/export-modified', {
          responseType: 'blob'
        })
        .then((resp) => {
          FileSaver.saveAs(
            resp.data,
            'liste des acteurs ajoutes-modifies.xlsx'
          )

          this.loadExcel = false
        })
        .catch((err) => {
          this.loadExcel = false
          this.$store.dispatch('responseMessage', {
            type: 'red',
            text: err
          })
        })
    },
    exportGlobalActors() {
      this.loadExcel = true
      axios
        .get('/api/actors/export', {
          responseType: 'blob'
        })
        .then((resp) => {
          FileSaver.saveAs(
            resp.data,
            'liste des acteurs.xlsx'
          )

          this.loadExcel = false
        })
        .catch((err) => {
          this.loadExcel = false
          this.$store.dispatch('responseMessage', {
            type: 'red',
            text: err
          })
        })
    },

    removeStartDate() {
      this.start_date = null;
      this.reloadData();
    },

    removeEndDate() {
      this.end_date = null;
      this.reloadData();
    }

  }
}
</script>
<style>
thead {
  background-color: #78b943;
}

thead th {
  color: #fff !important;
}

thead th i {
  color: #fff !important;
}

.v-pagination {
  flex-wrap: wrap;
}

.v-data-table td,
.v-data-table th {
  padding: 0 5px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/actors/index.vue